import { getSessionUserInfo } from './session/getSessionUserInfo';

export const getUserRegions = () => {
  const userInfo = getSessionUserInfo();

  if (!userInfo) return [];
  const fastMK2Role = userInfo?.roleAssociations?.find(
    (role) => role?.application === 'Fast & MK2',
  );

  if (!fastMK2Role?.tags?.length) return [];

  return [
    ...new Set(fastMK2Role.tags.filter((tag) => tag?.tagType === 'region').map((tag) => tag.name)),
  ];
};
